/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;

export default function init() {
    window.addEventListener("load", function () {
        initSelectEvents();
        initIndustriesInteraction();

        window.onpopstate = function (e: any) {
            if (e.state) {
                $("#blocksAppend").html(e.state.content).hide().fadeIn();

                document.title = e.state.pageTitle;

                $("#marketCode").val(e.state.marketCode);
                $("#countryCode").val(e.state.countryCode);
                $("#stateCode").val(e.state.stateCode);

                setCheckboxesGroups(
                    e.state.industries.split(","),
                    "industriesCheck_",
                    "industriesCheck"
                );

                $(".js-page-link")
                    .off("click")
                    .click(function () {
                        search($(this).data("pagenumber"), false, true);
                    });
            }
        };
    });

    function initSelectEvents() {
        statesInteraction(true);

        $("#marketCode").change(function () {
            countriesInteraction();
        });

        $("#countryCode").change(function () {
            statesInteraction(false);
        });

        $("#stateCode").change(function () {
            search(1, false, true);
        });
    }

    function initIndustriesInteraction() {
        $(".industriesCheck").change(function () {
            let industriesCheckeds = $(".industriesCheck:checked");
            industriesCheckeds.length > 0
                ? $("#applyIndustriesFilter")
                    .removeClass("disabled")
                    .removeAttr("disabled")
                : $("#applyIndustriesFilter")
                    .addClass("disabled")
                    .prop("disabled", "disabled");
        });

        if ($(".industriesCheck:checked").length > 0) {
            industriesFilterInteraction(false);
        }

        $("#applyIndustriesFilter").click(function () {
            industriesFilterInteraction(true);
        });

        $("#clearIndustriesFilter").click(function () {
            $("#applyFilterDiv").removeClass("d-none");
            $("#applyFilterDiv").parent().removeClass("active-filters");
            $("#selectedFilters").html("");
            $(".industriesCheck").prop("checked", false);
            $("#clearFilterDiv").addClass("d-none");
            $("#applyIndustriesFilter")
                .addClass("disabled")
                .prop("disabled", "disabled");

            search(1, false, true);
        });
    }

    function industriesFilterInteraction(doSearch: boolean) {
        $("#applyFilterDiv").addClass("d-none");

        let industriesCheckeds = $(".industriesCheck:checked");

        $.each(industriesCheckeds, function (index, industry) {
            let industryVal = $(industry).val();
            let industryText = $(industry).siblings("span").text();

            $("#selectedFilters").append(
                "<span class='pill pill--close mr-2 mb-2'>" +
                industryText +
                "<span class='pill__close' data-industryId='" +
                industryVal +
                "'></span></span>"
            );
        });

        $(".pill__close")
            .off("click")
            .click(function () {
                let $this = $(this);
                let industryId = $this.data("industryid");
                $("#industriesCheck_" + industryId).prop("checked", false);
                $this.parent("span").remove();

                if ($("#selectedFilters").children().length === 0) {
                    $("#applyFilterDiv").removeClass("d-none");
                    $("#applyFilterDiv").parent().removeClass("active-filters");
                    $("#clearFilterDiv").addClass("d-none");
                    $("#applyIndustriesFilter")
                        .addClass("disabled")
                        .prop("disabled", "disabled");
                }

                search(1, false, true);
            });

        $("#clearFilterDiv").removeClass("d-none");
        $("#clearFilterDiv").parent().addClass("active-filters");

        if (doSearch) {
            search(1, false, true);
        }
    }

    function countriesInteraction() {
        let val = $("#marketCode").val();
        let countryCode = $("#countryCode");
        $(".salesServiceBlock, .emptyServiceCentres, #paginationNav").remove();

        $("#stateCode").parent().addClass("d-none");
        $("#stateCode").val("");
        countryCode.attr("disabled", "disabled").html("");
        countryCode.append("<option disabled='disabled' selected></option>");

        if (val) {
            $("#countryCode").removeAttr("disabled");

            $.get("/api/GetCountries/" + val)
                .done(function (data) {
                    $.each(data, function (index, value) {
                        var option = document.createElement("option");
                        option.appendChild(document.createTextNode(value.text));
                        option.value = value.value;
                        countryCode.append(option);
                    });
                })
                .fail(function (error) {
                    Swal.fire("Oops...", error.responseJSON.Message, "error");
                });
        }
    }

    function statesInteraction(replaceState: boolean) {
        let countryCode = $("#countryCode").val();

        $("#stateCode").val("");

        if (countryCode === "US" || countryCode === "CA") {
            $(".salesServiceBlock, .emptyServiceCentres, #paginationNav").remove();
            $("#stateCode").parent().removeClass("d-none");

            let stateCode = $("#stateCode");
            stateCode.html("");
            stateCode.append("<option disabled='disabled' selected></option>");

            $.get("/api/getstates/" + countryCode + "/")
                .done(function (data) {
                    $.each(data, function (index, value) {
                        var option = document.createElement("option");
                        option.appendChild(document.createTextNode(value.text));
                        option.value = value.value;
                        stateCode.append(option);
                    });

                    let selectedState = $("#selectedState").val();

                    if (selectedState) {
                        $("#stateCode").val(selectedState);

                        search(
                            replaceState ? $("#requested-page").val() : 1,
                            replaceState,
                            false
                        );
                    }
                })
                .fail(function (error) {
                    Swal.fire("Oops...", error.responseJSON.Message, "error");
                });
        } else {
            $("#stateCode").parent().addClass("d-none");

            search(
                replaceState ? $("#requested-page").val() : 1,
                replaceState,
                false
            );
        }
    }

    function search(page: any, replaceState: boolean, jumpToTop: boolean) {
        let marketCode = $("#marketCode").val();
        let countryCode = $("#countryCode").val();
        let stateCode = $("#stateCode").val();
        let pageContentGuid = $("#pageContentGuid").val();

        if (jumpToTop === true) {
            $("html, body").animate(
                {
                    scrollTop: $("#blocksAppend").offset().top,
                },
                500
            );
        }

        let industries: any = [];
        let industriesCheckeds = $(".industriesCheck:checked");
        $.each(industriesCheckeds, function (index, industry) {
            let industryVal = $(industry).val();
            industries.push(industryVal);
        });

        // Just do the search if countries and markets dropdown attend condition
        if (
            !!marketCode &&
            !!countryCode &&
            ((countryCode !== "US" && countryCode !== "CA") || !!stateCode)
        ) {
            $(".salesServiceBlock, .emptyServiceCentres, #paginationNav").remove();
            $("#salesServiceBlockLoader").removeClass("d-none");
            let language = $("#hiddenLanguageCode").val();

            // Used for just render the last ajax call
            let seqNumber = ++xhrNumber;
            $.get("/salesservicespage/salesservicesblocks/", {
                marketCode: marketCode,
                countryCode: countryCode,
                stateCode: stateCode,
                industries: industries.toString(),
                pageContentGuid: pageContentGuid,
                page,
                language: language,
            })
                .done(function (data) {
                    if (xhrNumber === seqNumber) {
                        $(
                            ".salesServiceBlock, .emptyServiceCentres, #paginationNav"
                        ).remove();
                        $("#salesServiceBlockLoader").removeClass("d-none");
                        $("#blocksAppend").html(data).hide().fadeIn();

                        $(".js-page-link")
                            .off("click")
                            .click(function () {
                                search($(this).data("pagenumber"), false, true);
                            });

                        let currentPage = $("#current-page").val();

                        let title = document.title + " - " + currentPage;

                        if (!replaceState) {
                            history.pushState(
                                {
                                    content: data,
                                    pageTitle: title,
                                    marketCode: marketCode,
                                    countryCode: countryCode,
                                    stateCode: stateCode,
                                    industries: industries.toString(),
                                },
                                title,
                                "?page=" +
                                currentPage +
                                "&marketCode=" +
                                marketCode +
                                "&countryCode=" +
                                countryCode +
                                "&stateCode=" +
                                stateCode +
                                "&industries=" +
                                industries.toString()
                            );
                        } else {
                            history.replaceState(
                                {
                                    content: data,
                                    pageTitle: title,
                                    marketCode: marketCode,
                                    countryCode: countryCode,
                                    stateCode: stateCode,
                                    industries: industries.toString(),
                                },
                                title,
                                "?page=" +
                                currentPage +
                                "&marketCode=" +
                                marketCode +
                                "&countryCode=" +
                                countryCode +
                                "&stateCode=" +
                                stateCode +
                                "&industries=" +
                                industries.toString()
                            );
                        }
                    }
                })
                .fail(function (error) {
                    if (xhrNumber === seqNumber) {
                        Swal.fire("Oops...", error.statusText, "error");

                        $("#blocksAppend").fadeIn();
                    }
                })
                .always(function () {
                    if (xhrNumber === seqNumber) {
                        $("#salesServiceBlockLoader").addClass("d-none");
                    }
                });
        }
    }

    function setCheckboxesGroups(
        array: string[],
        selector: string,
        group: string
    ) {
        $("." + group).prop("checked", false);

        $.each(array, function (index, value) {
            let elem = document.getElementById(selector + value);

            if (elem) {
                $(elem).prop("checked", true);
            }
        });
    }
}
init();
